import React from 'react';

import {
  Row,
  Col,
} from 'react-bootstrap';

import RequiredMark from './RequiredMark';



const TitleRow = props => (
  <Row style={props.style}>
    <Col sm={props.sm || 12}>
      <div style={{fontWeight: "bold", marginBottom: 5}}>
        {props.required ? <RequiredMark /> : ""}{props.title || '標題'}

        {props.children}

      </div>
    </Col>
  </Row>
);

export default TitleRow;




// WEBPACK FOOTER //
// ./src/commonComponents/TitleRow.jsx